module.exports = __webpack_public_path__ + "static/media/nissan-bumper_selected.b92a4603.svg";